import React, { useRef } from "react";
import { Box, useMediaQuery } from "@mui/material";
import SiteHeader from "../components/layout/SiteHeader";
import Banner from "../components/Banner";
import SearchCard from "../components/SearchCard";
import Destinations from "../components/Destinations";
import { fetchdestinations } from "../utils/boatApi";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import ReviewCards from "../components/common/ReviewCards";
import CookieConsentBanner from "../components/general/CookieConsentBanner";
import { message } from "antd";
import BoatsAvailability from "../components/BoatsAvailability";

interface Destination {
  code: string;
  country: string;
  value: number; // Adjust based on API response
  imageURL: string;
}

const Home = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [destinations, setDestinations] = React.useState<Destination[]>([]); // Correct type
  const [loader, setLoader] = React.useState<boolean>(true);
  const [loader1, setLoader1] = React.useState<boolean>(true);
  const searchResults = useSelector(
    (state: RootState) => state.search.searchResults
  );
  const isFirstRender = useRef(true);

  // Hooks to check screen size
  const isSmallScreen = useMediaQuery("(max-width:900px)");
  const searchtext = location.state?.location;

  const countryMap: any = {
    ES: "Spain",
    FR: "France",
    GR: "Greece",
    HR: "Croatia",
    IT: "Italy",
    TR: "Turkey",
  };

  React.useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (
      searchResults?.count > 0 &&
      !location.pathname.startsWith("/yacht-details")
    ) {
      navigate("/search-results");
    }
    if (!isFirstRender.current && searchResults?.count === 0) {
      toast.error("No boats available!");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchResults]);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetchdestinations();

        if (res?.status === 200) {
          const imageUrls = [
            "/assets/images/1.jpg",
            "/assets/images/2.jpg",
            "/assets/images/3.jpg",
            "/assets/images/4.jpg",
            "/assets/images/5.jpg",
            "/assets/images/6.jpg",
          ];

          const ORDER = ['GR', 'IT', 'HR', 'TR', 'ES', 'FR'];
          const result: Destination[] = Object.entries(res.data)
            .map(([code, value]) => ({
              code,
              country: countryMap[code],
              value: Number(value),
              imageURL: '',
            }))
            .sort((a, b) => ORDER.indexOf(a.code) - ORDER.indexOf(b.code))
            .map((dest, index) => ({
              ...dest,
              imageURL: imageUrls[index % imageUrls.length],
            }));

          setDestinations(result);
        } else {
          message.error("Failed to fetch destinations");
        }
      } catch (error) {
        message.error("Error fetching destinations. Please try again later.");
      } finally {
        setLoader1(false);
        setLoader(false); // Ensure the loader stops in both success and failure cases
      }
    };

    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      <SiteHeader />
      {!isSmallScreen && (
        <Banner>
          <SearchCard searchtext={searchtext} setLoader={setLoader1} />
          <ReviewCards />
        </Banner>
      )}

      {isSmallScreen && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "20px",
            marginTop: "calc(var(--banner-height, 0px) + var(--nav-height, 68px))",
            padding: "16px",
          }}
        >
          <SearchCard searchtext={searchtext} setLoader={setLoader1} />
        </Box>
      )}
      {location.pathname.startsWith("/yacht-details") ? (
        <BoatsAvailability destinations={destinations} loader={loader1} />
      ) : (
        <Destinations destinations={destinations} loader={loader} />
      )}
      <CookieConsentBanner />
    </Box>
  );
};

export default Home;
